import React from 'react'
import { useSelector } from 'react-redux'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { selectAdminAgents } from 'selectors/agents/base'
import { SUI } from 'shared/ui'

const AdminList = () => {
  const admins = useSelector(selectAdminAgents)
  return (
    <p
      css={[text.styles.textNormal, text.styles.textDark]}
      className="grui mt-15"
    >
      {admins.map(admin => (
        <SUI>
          <strong>{admin.name}</strong>
          {' - '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`mailto:${admin.email}?subject=Chat%20access%20on%20Groove`}
          >
            {admin.email}
          </a>
          <br />
        </SUI>
      ))}
    </p>
  )
}

export default AdminList
